import { render, staticRenderFns } from "./pocketmoneybalances.vue?vue&type=template&id=08f9856f&"
import script from "./pocketmoneybalances.vue?vue&type=script&lang=js&"
export * from "./pocketmoneybalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports